/* ANKHGEAR landing pages: phones get portrait posters, browsers without H.264 get VP9,
   and looping clips only play while they are on screen. */
/* each page opens at its top (the preview frame otherwise carries the old scroll position over) */
(function () {
  if (location.hash) return;
  try { history.scrollRestoration = 'manual'; } catch (e) {}
  scrollTo(0, 0); addEventListener('load', function () { scrollTo(0, 0); });
})();
/* tapping the link for the page you're already on (header, tabs, logo) glides back to the top */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href]'); if (!a || e.metaKey || e.ctrlKey) return;
  var u = new URL(a.getAttribute('href'), location.href);
  if (u.pathname === location.pathname && !u.hash && u.origin === location.origin) { e.preventDefault(); scrollTo({ top: 0, behavior: 'smooth' }); }
});
(function () {
  var phone = matchMedia('(max-width: 760px)').matches;
  if (phone) document.querySelectorAll('img[data-mobile]').forEach(function (i) { i.src = i.getAttribute('data-mobile'); });
  var v = document.createElement('video');
  if (!v.canPlayType('video/mp4; codecs="avc1.640028"')) {
    document.querySelectorAll('[data-sc-src]').forEach(function (e) { ['data-sc-src', 'data-sc-src-mobile'].forEach(function (a) { var x = e.getAttribute(a); if (x) e.setAttribute(a, x.replace(/\.mp4$/, '.webm')); }); });
    document.querySelectorAll('video[data-webm]').forEach(function (e) { e.src = e.getAttribute('data-webm'); });
  }
  window.agLoops = function () {
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vids = document.querySelectorAll('video.loop');
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { if (e.target.dataset.userPaused) return; e.target.preload = 'auto'; var pr = e.target.play(); if (pr && pr.catch) pr.catch(function () {}); } else e.target.pause(); });
      }, { threshold: 0.3 });
      vids.forEach(function (x) { io.observe(x); });
    } else vids.forEach(function (x) { x.controls = true; });
    if (!reduce) (function(){
/* play/pause: every looping clip gets a small button in its top corner. A clip someone pauses stays paused. */
(function () {
  var P = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
  var Y = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  if (!document.getElementById('vpp-css')) {
    var st = document.createElement('style'); st.id = 'vpp-css';
    st.textContent = '.vpp{position:absolute;top:.6rem;right:.6rem;z-index:6;width:38px;height:38px;border-radius:50%;border:0;display:grid;place-items:center;cursor:pointer;background:rgba(33,30,22,.62);color:#fff;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:.85;transition:opacity 150ms}.vpp:hover,.vpp:focus-visible{opacity:1}.vpp svg{width:18px;height:18px;fill:currentColor}';
    document.head.appendChild(st);
  }
  document.querySelectorAll('video.loop').forEach(function (v) {
    var box = v.parentNode; if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'vpp';
    function sync() { var on = !v.paused; b.innerHTML = on ? P : Y; b.setAttribute('aria-label', on ? 'Pause video' : 'Play video'); }
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation();
      if (v.paused) { v.dataset.userPaused = ''; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.dataset.userPaused = '1'; v.pause(); } });
    v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
    box.appendChild(b);
  });
})();

})();
  };
})();

/* "Shop all products" link: footer Shop column on every page, plus the header menu */
(function () {
  function go() {
    document.querySelectorAll('.site__cols > div:first-child').forEach(function (col) {
      if (col.querySelector('a[href="/collections/all"]')) return;
      var a = document.createElement('a'); a.href = '/collections/all'; a.textContent = 'Shop all products';
      var z = col.querySelector('a[href="/pages/zipperbuddy"]'); z ? z.after(a) : col.appendChild(a);
    });
    var here = location.pathname === '/collections/all';
    document.querySelectorAll('header.bar nav, nav.tabs').forEach(function (n) {
      if (n.querySelector('a[href="/collections/all"]')) return;
      var a = document.createElement('a'); a.href = '/collections/all'; a.textContent = 'Shop all';
      if (here) a.setAttribute('aria-current', 'page');
      var s = n.querySelector('a[href="/pages/our-story"]'); s ? n.insertBefore(a, s) : n.appendChild(a);
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', go) : go();
})();
